import React from "react";
import { useSelector } from "react-redux";

import TopNavBarSpan from "./TopNavBarSpan";
import UserMenu from "./UserMenu";
import TopSubNavBar from "./TopSubNavBar";
import "./TopNavBar.css";

// 기본 로고: 지인에듀 말풍선 (학원 로고 없을 때)
const DefaultLogo = () => (
  <span className="teacher-nav__default-logo">
    <svg viewBox="0 0 64 48" xmlns="http://www.w3.org/2000/svg" className="teacher-nav__default-logo-mark">
      <path d="M22 4a17 17 0 1 0 0 34c1.2 0 2.4-.13 3.5-.37L20 46l12-9.5A17 17 0 0 0 22 4z" fill="#171D26" />
      <path d="M42 8a15.5 15.5 0 1 1 0 31c-1 0-2-.1-3-.3L44 46l-9.5-8.3A15.5 15.5 0 0 1 42 8z" fill="#00D9C0" />
    </svg>
    <span className="teacher-nav__default-logo-text">ECHO</span>
  </span>
);

const TopNavBar = ({
  topTab,
  subTab,
  selectTab,
  selectSubTab,
  tabList,
}) => {
  const { user } = useSelector((state) => state.auth);

  return (
    <div>
      <div className="teacher-nav">
        <div className="teacher-nav__inner">
          {/* 왼쪽: 학원 로고 (없으면 ECHO 기본 로고) */}
          <div className="teacher-nav__side">
            {user.logo_img ? (
              <img src={user.logo_img} alt="logo" className="teacher-nav__logo" />
            ) : (
              <DefaultLogo />
            )}
          </div>

          <div className="teacher-nav__tabs">
            {tabList.map((tab) => (
              <TopNavBarSpan
                key={tab.name}
                topTab={topTab}
                selectTab={selectTab}
                tabName={tab.name}
                tabText={tab.text}
              />
            ))}
          </div>

          {/* 오른쪽: 로그인한 계정 */}
          <div className="teacher-nav__side teacher-nav__side--right">
            <UserMenu />
          </div>
        </div>
      </div>

      <TopSubNavBar
        topTab={topTab}
        subTab={subTab}
        selectSubTab={selectSubTab}
        tabList={tabList}
      />
    </div>
  );
};

export default TopNavBar;
